import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Skeleton from "react-loading-skeleton";

const SingleItem = ({ data }) => {
  const [livePrice, setLivePrice] = useState([]);
  const [loading, setLoading] = useState(true);
  const { crypto_currency_id: cryptoCurrencyData } = data;

  useEffect(() => {
    const interval = setInterval(() => {
      fetchData();
    }, 1000);
    return () => clearInterval(interval);
  }, [livePrice]);

  const fetchData = async () => {
    if (cryptoCurrencyData !== null) {
      fetch(
        `https://api.massive.com/v2/snapshot/locale/global/markets/crypto/tickers/X:${cryptoCurrencyData?.Symbol}${cryptoCurrencyData?.currency}?apiKey=${process.env.REACT_APP_POLYGON_API_KEY}`,
        {
          method: "GET",
        }
      )
        .then((res) => res.json())
        .then((data) => {
          if (data?.ticker) {
            setLivePrice(data?.ticker);
          }
          if (loading) {
            setLoading(false);
          }
        })
        .catch((error) => {
          // console.log(error);
        });
    }
  };

  if (loading || cryptoCurrencyData === null) {
    return;
  }
  return (
    <>
      <div className="markets-coin">
        <Link to="#">
          <div className="markets-coin-left">
            <div className="markets-coin-image">
              <LazyLoadImage
                effect="blur"
                alt="img"
                src={`https://api.wlffinance.org/${cryptoCurrencyData?.image}`}
                className="hot-coin-img"
              />
            </div>
            <div className="markets-coin-name">
              <h4> {cryptoCurrencyData?.Name}</h4>
              <h5>{cryptoCurrencyData?.Symbol}</h5>
            </div>
          </div>
          <div className="markets-coin-right">
            <div className="markets-coin-price">
              <p>
                $
                {!isNaN(livePrice?.lastTrade?.p) &&
                  parseFloat(livePrice?.lastTrade?.p) +
                    parseFloat(cryptoCurrencyData?.price)}
              </p>
            </div>
            <div className="markets-coin-percentage">
              <p
                className={`${
                  livePrice?.todaysChangePerc >= 0 ? "up-price" : "dwon-price"
                }`}
              >
                <i class="fa-solid fa-arrow-right"></i>
                {parseFloat(livePrice?.todaysChangePerc).toFixed(2)}%
              </p>
            </div>
          </div>
        </Link>
      </div>
    </>
  );
};



//  (
//       <section className="mobile-version">
//         <div className="Mobile-version-slider">
//           <Skeleton count={2} height={35} />
//         </div>
//       </section>
//     );

export default SingleItem;
